import { createPortal, useRef } from 'preact/compat'
import Icon from '@/components/snippets/icon/icon'

export const SearchHeader = ({ query, totalResults, isLoading, corrections }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  const focusSearch = (containerId) => {
    const searchContainer = document.querySelector(`#${containerId} input[name="query"]`)
    if (searchContainer) {
      setTimeout(() => {
        searchContainer.focus()
      }, 100)
    }
  }

  return createPortal(
    (hasMounted.current || !isLoading) && (
      <div className="flex flex-col gap-y-1.5 w-full pt-2 lg:pt-3 pb-1.5 lg:pb-2" data-results={totalResults}>
        <div className="flex flex-col gap-y-1.5">
          <h2 className="h5 font-medium">
              {totalResults > 0
                ? `Showing ${totalResults} results`
                : 'Sorry, no results found'}
          </h2>
          {corrections?.corrected && (
              <div className="paragraph-s">
                  <p>No results found for "{query}". Showing results for "{corrections.corrected}" instead.</p>
              </div>
          )}
          {corrections?.didYouMean && (
              <div className="paragraph-s">
                  <p>Did you mean: <a href={`/search?query=${corrections.didYouMean}`} className='link-fade' aria-label={`Search for ${corrections.didYouMean}`}>{corrections.didYouMean}</a></p>
              </div>
          )}
          {totalResults === 0 && !isLoading && (
              <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
          )}
        </div>
          <x-button class="hidden lg:flex items-center gap-x-0.75 w-full h6 font-medium pb-0.75 border-b border-primary link-fade" data-modal-parent="quick-search-desktop" data-modal-role="open" aria-label="Search Again Desktop" onClick={() => focusSearch('quick-search-desktop')}>
            <div className="flex size-[17px] children:size-full">
              <Icon id="magnifying-glass" />
            </div>
            {query || <span className="text-neutral-secondary">Search again</span>}
          </x-button>
          <x-button class="flex lg:hidden items-center gap-x-0.75 w-full h6 font-medium pb-0.75 border-b border-primary link-fade" data-modal-parent="quick-search-mobile" data-modal-role="open" aria-label="Search Again Mobile" onClick={() => focusSearch('quick-search-mobile')}>
            <div className="flex size-[17px] children:size-full">
              <Icon id="magnifying-glass" />
            </div>
            {query || <span className="text-neutral-secondary">Search again</span>}
          </x-button>
      </div>
    ), searchHeader
  )
}
